<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
<div id="item-detail-page">
    <vx-card v-if="item_data" :key="item_data.code">
        <template slot="no-body">
            <div class="item-content">
                <!-- Item Main Info -->
                <div class="product-details p-6">
                    <div class="vx-row mt-6">
                        <div class="vx-col md:w-2/5 w-full flex items-center justify-center">
                            <div class="product-img-container w-3/5 mx-auto mb-10 md:mb-0">
                                <img :src="imgURL1" :alt="item_data.designation" class="responsive" />
                            </div>
                        </div>

                        <!-- Item Content -->
                        <div class="vx-col md:w-3/5 w-full">
                            <h3>{{ item_data.designation }}</h3>

                            <p class="my-2 row-gap-0">
                                <span class="mr-2">by</span> <span class="mr-2">{{ item_data.fournisseur }}</span>
                                <!-- <span>
                                    <h2>{{ item_data.fournisseur }}</h2>
                                </span> -->
                            </p>
                            <p class="flex items-center flex-wrap">
                                <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2">{{ item_data.prix.substring(0,5) }} DT</span>
                                <span class="pl-4 mr-2 mt-2 border border-solid d-theme-border-grey-light border-t-0 border-b-0 border-r-0">
                                    <star-rating :show-rating="false" :rating="item_data.rating" :star-size="20" read-only />
                                </span>
                                <span class="cursor-pointer leading-none mt-2">424 ratings</span>
                            </p>

                            <vs-divider />

                            <p>{{ item_data.designation }}</p>

                            <vs-list class="product-sales-meta-list px-0 pt-4">
                                <vs-list-item class="p-0 border-none" :title="'Code : '+ item_data.code" icon-pack="feather" icon="icon-tag" />
                                <vs-list-item class="p-0 border-none" :title="'Catégorie : '+ item_data.categorie" icon-pack="feather" icon="icon-info" />
                                <vs-list-item class="p-0 border-none" :title="'Classe thérapeutique : '+ item_data.classe" icon-pack="feather" icon="icon-git-branch" />
                                <vs-list-item class="p-0 border-none" :title="'DCI 1 : '+ item_data.dci1" icon-pack="feather" icon="icon-chevron-right" />
                                <vs-list-item class="p-0 border-none" :title="'DCI 2 : '+ item_data.dci2" icon-pack="feather" icon="icon-chevron-right"></vs-list-item>
                            </vs-list>

                            <vs-divider />

                            <!-- /Color -->

                            <vs-divider />

                            <!-- Quantity -->
                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <p class="my-2">
                                        <span>Available</span>
                                        <span class="mx-2">-</span>
                                        <span class="text-success">In Stock</span>
                                    </p>
                                </div>

                                <div class="vx-col w-full" style="margin-top:5%;margin-bottom:5%">
                                    <div class="flex flex-wrap items-start mb-4">
                                        <!-- Add To Cart Button -->
                                        <vs-button class="mr-4 mb-4" icon-pack="feather" icon="icon-shopping-cart" v-if="!isInCart(item_data.objectID)" @click="toggleItemInCart(item_data)">ADD TO CART</vs-button>

                                        <vs-button v-else class="mr-4 mb-4" icon-pack="feather" icon="icon-shopping-cart" @click="$router.push({name: 'ecommerce-checkout'}).catch(err => {})">VIEW IN CART</vs-button>
                                        <!-- /Add To Cart Button -->

                                        <!-- Wishlist Button -->
                                        <vs-button v-if="isInWishList(item_data.objectID)" key="filled" class="mb-4" icon-pack="feather" icon="icon-heart" color="danger" @click="toggleItemInWishList(item_data)">WHISHLIST</vs-button>

                                        <vs-button v-else key="border" class="mb-4" type="border" icon-pack="feather" icon="icon-heart" color="danger" @click="toggleItemInWishList(item_data)">WHISHLIST</vs-button>
                                        <!-- /Wishlist Button -->
                                    </div>
                                </div>
                            </div>
                            <!-- /Quantity -->

                            <div class="vx-row">
                                <div class="vx-col flex flex-wrap items-center">
                                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#1551b1" icon="icon-facebook" radius></vs-button>
                                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#00aaff" icon="icon-twitter" radius></vs-button>
                                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#c4302b" icon="icon-youtube" radius></vs-button>
                                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#405DE6" icon="icon-instagram" radius></vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Product Feature/Meta Row -->
                <div class="py-24 mb-16 mt-10 text-center item-features">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/3 w-full">
                            <div class="w-64 mx-auto mb-16 md:mb-0">
                                <feather-icon icon="AwardIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                <span class="font-semibold text-lg">100% Original</span>
                                <p class="mt-2">Chocolate bar candy canes ice cream toffee cookie halvah.</p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full">
                            <div class="w-64 mx-auto mb-16 md:mb-0">
                                <feather-icon icon="ClockIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                <span class="font-semibold text-lg">10 Day Replacement</span>
                                <p class="mt-2">Marshmallow biscuit donut dragée fruitcake wafer.</p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full">
                            <div class="w-64 mx-auto">
                                <feather-icon icon="ShieldIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                <span class="font-semibold text-lg">1 Year Warranty</span>
                                <p class="mt-2">Cotton candy gingerbread cake I love sugar sweet.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Related Products -->
            <div class="related-products text-center px-6" id="item-recommandation">
                <div class="related-headings mb-8 text-center">
                    <h2 class="uppercase">Related Products</h2>
                    <p>People also search for this items</p>
                    <swiper :options="swiperOption" class="related-product-swiper px-12 py-6">
                        <swiper-slide v-for="(item, indextr) in this.related_items" :key="indextr" class="p-6 rounded cursor-pointer">
                            <item-recommandation :item="item">
                            </item-recommandation>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </div>

        </template>
    </vx-card>
</div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import articleServ from '@/http/requests/article/index.js'
import {
    swiper,
    swiperSlide
} from "vue-awesome-swiper";
import StarRating from "vue-star-rating";

export default {
    components: {
        swiper,
        swiperSlide,
        StarRating,
        ItemRecommandation: () => import("./ItemRecommandation.vue"),
    },
    data() {
        return {
            imgURL1: require("@/assets/images/logo/cogepha-01.png"),
            imgURL2: require("@/assets/images/logo/cogepha-01.png"),
            imgURL3: require("@/assets/images/logo/cogepha-01.png"),
            item_data: null,
            error_occured: false,
            error_msg: "",
            opt_color: "#7367F0",
            is_hearted: false,
            related_items: [],
            swiperOption: {
                slidesPerView: 5,
                spaceBetween: 55,
                breakpoints: {
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 55
                    },
                    1300: {
                        slidesPerView: 3,
                        spaceBetween: 55
                    },
                    900: {
                        slidesPerView: 2,
                        spaceBetween: 55
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 55
                    }
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
        };
    },
    watch: {
        '$route.params.item_id'() {
            this.fetch_item_details(this.$route.params.item_id);
        }
    },
    computed: {
        isInWishList() {
            return itemId => this.$store.getters["eCommerce/isInWishList"](itemId);
        },
        isInCart() {
            return itemId => this.$store.getters["eCommerce/isInCart"](itemId);
        }
    },
    methods: {
        getImage(code) {
            articleServ.getimageByCodeArticle(code).then(response => {
                if (response.data.length > 0) {
                    return 'data:image/jpeg;base64,' + response.data[0].content
                } else {
                    return require("../avatar-2.jpg")
                }
            }).catch(() => {
                return require("../avatar-2.jpg")
            })
        },
        toggleItemInWishList(item) {
            this.$store.dispatch("eCommerce/toggleItemInWishList", item);
        },
        toggleItemInCart(item) {
            this.$store.dispatch("eCommerce/toggleItemInCart", item);
        },
        fetch_item_details(id) {
            const result = this.$store.state.article.articles.filter(
                item => item.code == id
            );
            this.item_data = result[0]
            articleServ.getimageByCodeArticle(id).then(response => {
                if (response.data.length > 0) {
                    this.imgURL1 = 'data:image/jpeg;base64,' + response.data[0].content
                    if (response.data.length > 1)
                        this.imgURL2 = 'data:image/jpeg;base64,' + response.data[1].content
                    if (response.data.length > 2)
                        this.imgURL3 = 'data:image/jpeg;base64,' + response.data[2].content
                } else {
                    this.imgURL1 = require("@/assets/images/logo/cogepha-01.png")
                    this.imgURL2 = require("@/assets/images/logo/cogepha-01.png")
                    this.imgURL3 = require("@/assets/images/logo/cogepha-01.png")
                }
            }).catch(() => {
                this.imgURL1 = require("@/assets/images/logo/cogepha-01.png")
                this.imgURL2 = require("@/assets/images/logo/cogepha-01.png")
                this.imgURL3 = require("@/assets/images/logo/cogepha-01.png")
                if (this.isTheLast) {
                    this.$vs.loading.close();
                }
            })
            this.related_items = this.$store.state.article.articles.filter(function (element) {
                return element.dci1 == result[0].dci1 &&
                    element.dci2 == result[0].dci2 &&
                    element.fournisseur == result[0].fournisseur &&
                    element.classe == result[0].classe &&
                    element.code != result[0].code;
            }).slice(0, 20);
        }
    },
    created() {
        this.fetch_item_details(this.$route.params.item_id);
    },
    destroyed() {
        if (this.$router.app._route.name != 'catalogue-shop') {
            this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", 'vertical')
            this.$store.dispatch('TOGGLEREDUCEBUTTON', false);
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";

#item-detail-page {
    .color-radio {
        height: 2.28rem;
        width: 2.28rem;

        >div {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .item-features {
        background-color: #f7f7f7;

        .theme-dark & {
            background-color: $theme-dark-secondary-bg;
        }
    }

    .product-sales-meta-list {
        .vs-list--icon {
            padding-left: 0;
        }
    }

    .related-product-swiper {
        // padding-right: 2rem;
        // padding-left: 2rem;

        .swiper-wrapper {
            padding-bottom: 2rem;

            >.swiper-slide {
                background-color: #f7f7f7;
                box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
                    0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;

                .theme-dark & {
                    background-color: $theme-light-dark-bg;
                }
            }
        }

        .swiper-button-next,
        .swiper-button-prev {
            transform: scale(0.5);
            filter: hue-rotate(40deg);
        }

        .swiper-button-next {
            right: 0;
        }

        .swiper-button-prev {
            left: 0;
        }
    }
}
</style>
